import { SxProps } from "@mui/material";

/**
 * Shared styles for mobile input fields to prevent zoom on focus
 * Ensures minimum 16px font size for all input elements
 */
export const mobileInputSx: SxProps = {
  "& .MuiInputBase-input": {
    fontSize: "16px",
  },
};
